// extracted by mini-css-extract-plugin
export default {"description-list":"gWZO","descriptionList":"gWZO","container":"VWyO","term":"B1qV","value":"gGxq","empty-byte":"FS2s","emptyByte":"FS2s","highlight":"lKYa"};